import RequestsProcessor from '~/utils/requestsProcessor/requestsProcessor';

export default defineNuxtPlugin(() => {
  const {
    public: { apiBase }
  } = useRuntimeConfig();
  const baseUrl = apiBase || '/api';

  const rp = new RequestsProcessor(baseUrl);

  rp.registerRequestsHandler(async (url, options) => {
    const { method = 'GET', params, headers, body } = options;

    const _fetch = import.meta.server ? useRequestFetch() : $fetch;

    try {
      return await _fetch(url, {
        method,
        params,
        headers,
        body,
        responseType: 'json',
        parseResponse: JSON.parse,
        credentials: 'include'
      });
    } catch (err: any) {
      if (err?.statusCode && err.statusCode >= 400 && err.statusCode < 600) {
        throw new Error(`Request failed with status ${err.statusCode}: ${err.message || ''}`);
      }
      throw err;
    }
  });

  rp.registerRefreshMechanism(async () => {
    try {
      const _fetch = import.meta.server ? useRequestFetch() : $fetch;
      await _fetch(`${baseUrl}/auth/refresh`, { method: 'POST', credentials: 'include' });
      return true;
    } catch {
      return false;
    }
  });

  return {
    provide: {
      api: rp.api
    }
  };
});
